import { FC } from 'react';
import { PackageDetails } from 'ts/package/interfaces/PackageDetails';
import { useTranslation } from 'react-i18next';
import Rating from 'components/ui/Rating/Rating';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface HotelDescriptionProps {
  dealModel: PackageDetails;
}

const HotelDescription: FC<HotelDescriptionProps> = ({ dealModel: { info } }) => {
  const [t] = useTranslation();
  return (
    <div className="text-sm">
      <div className="mb-20">
        <div className="text-info">{t('hotel.name')}</div>
        <div>{info.hotelName}</div>
      </div>
      <div className="mb-20">
        <div className="text-info">{t('hotel.description')}</div>
        <div>{info.hotelLocation.description}</div>
      </div>
      <div className="mb-20">
        <div className="text-info">{t('search.star_rating')}</div>
        <div>
          <Rating value={info.hotelRate} />
        </div>
      </div>
      <div className="mb-20">
        <div className="text-info">{t('hotel.address')}</div>
        <div>{info.hotelLocation.address.street}</div>
      </div>
      <div className="mb-20">
        <div className="text-info">{t('passenger.phone')}</div>
        <div>{info.hotelLocation.address.phone}</div>
      </div>
      <div className="mb-20">
        <div className="text-info">{t('passenger.email')}</div>
        <div>
          <a href={`mailto:${info.hotelLocation.address.email}`}>
            {info.hotelLocation.address.email}
          </a>
        </div>
      </div>
      <div className="mb-20">
        <div className="text-info">{t('hotel.loc')}</div>
        <div>{info.hotelRemarks?.find((rem) => rem.remarkType === 'location')?.freeText}</div>
      </div>
    </div>
  );
};

export default withErrorBoundary(HotelDescription, 'HotelDescription');
